// Core Components
import React from 'react';

import Box from '@mui/material/Box';
import HelpIcon from '@mui/icons-material/Help';

export default function PageTitle(props) {
  const { Icon, title } = props;
  const TitleIcon = Icon || HelpIcon;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <TitleIcon sx={{ mr: 1 }} />
      {title}
    </Box>
  );
}
